import React from 'react';
import { ZapIcon } from 'lucide-react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from 'recharts';
const SEO_OUTLETS = [{
  name: 'SEO-01',
  location: '거실',
  usage: 12.4
}, {
  name: 'SEO-02',
  location: '안방',
  usage: 8.2
}, {
  name: 'SEO-03',
  location: '주방',
  usage: 5.1
}, {
  name: 'SEO-04',
  location: '욕실',
  usage: 2.8
}];
const BAR_COLORS = ['#a78bfa', '#818cf8', '#6366f1', '#4f46e5'];
export function OutletPowerChart() {
  const totalUsage = SEO_OUTLETS.reduce((sum, o) => sum + o.usage, 0);
  return <div className="glass-panel rounded-2xl p-4 flex flex-col gap-3 flex-1 h-full" data-id="element-167">
      <div className="flex items-center justify-between" data-id="element-168">
        <div className="flex items-center space-x-2 text-slate-400" data-id="element-169">
          <ZapIcon className="w-4 h-4 text-violet-400" data-id="element-170" />
          <span className="text-[11px] font-medium uppercase tracking-wider" style={{
          fontSize: "12px"
        }} data-id="element-171">
            콘센트별 전력 사용량
          </span>
        </div>
        <div className="flex items-baseline gap-1" data-id="element-172">
          <span className="text-sm font-mono font-bold text-violet-400" data-id="element-173">
            {totalUsage.toFixed(1)}
          </span>
          <span className="text-[9px] text-slate-500 font-mono" data-id="element-174">kWh</span>
        </div>
      </div>

      <div className="flex-1 min-h-[100px]" data-id="element-175">
        <ResponsiveContainer width="100%" height="100%" data-id="element-176">
          <BarChart data={SEO_OUTLETS} layout="vertical" margin={{
          top: 0,
          right: 8,
          bottom: 0,
          left: 0
        }} barCategoryGap="20%" data-id="element-177">
            <YAxis dataKey="name" type="category" axisLine={false} tickLine={false} width={52} tick={{
            fill: '#94a3b8',
            fontSize: 10,
            fontFamily: 'monospace'
          }} data-id="element-178" />
            <XAxis type="number" hide domain={[0, 'dataMax + 2']} data-id="element-179" />
            <Tooltip cursor={{
            fill: 'rgba(255,255,255,0.03)'
          }} contentStyle={{
            backgroundColor: '#0a0f1a',
            borderColor: 'rgba(255,255,255,0.1)',
            borderRadius: '8px',
            fontSize: '10px',
            fontFamily: 'monospace'
          }} itemStyle={{
            color: '#a78bfa'
          }} formatter={(value: number, _name: string, props: any) => {
            const item = SEO_OUTLETS.find(o => o.name === props.payload?.name);
            return [`${value} kWh`, item?.location || ''];
          }} labelFormatter={label => `${label}`} data-id="element-180" />
            <Bar dataKey="usage" radius={[0, 4, 4, 0]} barSize={14} data-id="element-181">
              {SEO_OUTLETS.map((_, i) => <Cell key={i} fill={BAR_COLORS[i % BAR_COLORS.length]} opacity={0.8} data-id="element-182" />)}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>

      {/* Location labels */}
      <div className="flex items-center gap-3 flex-wrap" data-id="element-183">
        {SEO_OUTLETS.map((outlet, i) => <div key={outlet.name} className="flex items-center gap-1.5" data-id="element-184">
            <span className="w-2 h-2 rounded-full" style={{
          backgroundColor: BAR_COLORS[i % BAR_COLORS.length]
        }} data-id="element-185" />
            <span className="text-[9px] text-slate-500 font-mono" data-id="element-186">
              {outlet.name}
            </span>
            <span className="text-[9px] text-slate-600" data-id="element-187">{outlet.location}</span>
          </div>)}
      </div>
    </div>;
}